const doc = [({"zh_cn":({"constantBookingStatus":({"arranged":"已预订", "cancelled":"已取消", "modified":"已经改变了", "requested":"请求"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;